<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">
          {{ 'general.create' | translate }}
        </li>
      </ol>
    </nav>

    <h1 class="page-header-title">
      {{ 'organizationModule.createOrganization' | translate }}
    </h1>
  </header>
  <!-- End Page Header -->

  <section class="card">
    <div class="card-body">
      <div>
        <organization-form
          (onSubmit)="onSubmit($event)"
          [disableSaveButton$]="disableSaveButton$.asObservable()"
        >
        </organization-form>
      </div>
    </div>
  </section>
</div>
